import LogOutZendeskContainer from "../containers/LogOutZendeskContainer";

const LogOutZendeskPage = () => {
  return <LogOutZendeskContainer />;
};

export default LogOutZendeskPage;
